import React from 'react'
export default <hr style={{ background: 'var(--color-bordergray)' }} />
